<template>
	<div>
    <search-list
      style="padding:26px 24px 0"
      @search="search"
    ></search-list>
		<div style="margin-left:20px">
			<Button type="primary" @click.stop="addN++">添加</Button>
		</div>

		<table-list
      style="padding:26px 24px 0"
			:columns="columns"
			:data="data"
			:current="current"
			:total="total"
			:loading="loading"
			@change-page="changePage"
		></table-list>

		<add
			:n="addN"
			:secondaryType="secondaryType"
			:secondaryYYType="secondaryYYType"
			:applyObject="applyObject"
			:projects="projects"
      @done="getSearchData"
		>
		</add>

		<update
			:n="addU"
      :labelFid="labelFid"
			:secondaryType="secondaryType"
			:secondaryYYType="secondaryYYType"
			:applyObject="applyObject"
			:projects="projects"
      @done="getSearchData"
		>

		</update>
	</div>
</template>

<script>
import SearchList from './components/SearchList'
import Add from './components/Add'
import Update from './components/Update'
import TableList from 'components/TableList/index';
import {getList,getConditionList,projectHoseTypeInfo,stopOrStartLabel} from 'api/labelmanage'
import {getYYConditionList} from "../../../api/labelmanage";
export default {
  components:{
		TableList,
		Add,
    Update,
    SearchList,
	},
	data(){
		return{
			addN:0,
			loading:false,
			total:0,
			current:1,
			addU:0,
			data:[],
			columns:[
        {
          title:'标签名称',
          key: 'labelName',
          width: 130,
          align: 'center'
        },
        {
          title: ' '
        },
        {
          title: ' '
				},
				{
          title:'显示顺序',
          key: 'labelOrder',
          width: 100,
          align: 'center',
          render:(h,params)=>{
						return h('span',{},params.row.labelOrder===null?'--':params.row.labelOrder)
					}
        },
        {
          title: ' '
        },
        {
          title:'描述',
          key: 'remark',
          width: 180,
          align: 'center',
        },
        {
          title: ' '
        },
        {
          title:'跳转链接',
          key: 'link',
          width: 200,
          align: 'center',
          render:(h,params)=>{
            if (params.row.link && params.row.link.length > 20) {
							return h('Tooltip', {
                  props: {
                    placement: "top"
                  }
                }, [
                  h('div', {
                    style: {
                      whiteSpace: 'normal'
                    },
                    slot: 'content',
                  }, params.row.link),
                  h('span',{style:{'line-height':'52px!important'}}, params.row.link.slice(0, 20) + '...')
                ])
						} else {
							return h('span', {}, params.row.link)
						}
					}
        },
        {
          title: ' '
        },
				{
					title:'标签类型',
					key: 'labelSecondaryTypeCn',
					width: 180,
					align: 'center',
				},
				{
					title: ' '
				},
        {
          title:'是否高亮',
          key: 'highLight',
          width: 100,
          align: 'center',
          render:(h,params)=>{
						return h('span',{},params.row.highLight===1?'是':'否')
					}
        },
        {
          title: ' '
				},
				{
          title:'状态',
          key: 'labelIsValid',
          width: 100,
					align: 'center',
					render(h,params){
            return h('span', {}, params.row.labelIsValid===1?'启用':'停用')
          }
        },
        {
          title: ' '
				},
				{
          title:'适用项目',
          key: 'projectOrHouseTypeNames',
          width: 200,
					align: 'center',
					render:(h,params)=>{
            if (params.row['projectOrHouseTypeNames'] && params.row['projectOrHouseTypeNames'].length > 10) {
							return h('Tooltip', {
                  props: {
                    placement: "top"
                  }
                }, [
                  h('div', {
                    style: {
                      whiteSpace: 'normal'
                    },
                    slot: 'content',
                  }, params.row['projectOrHouseTypeNames']),
                  h('span', {style:{'line-height':'52px!important'}}, params.row['projectOrHouseTypeNames'].slice(0, 10) + '...')
                ])
						} else {
							return h('span', {}, params.row['projectOrHouseTypeNames'])
						}
					}
        },
        {
          title: ' '
				},
				{
          title:'更新时间',
          key: 'lastModifyTime',
          width: 170,
          align: 'center'
        },
        {
          title: ' '
				},
				{
          title:'操作',
          width: 120,
          fixed:'right',
          align: 'center',
          render:(h,params)=>{
            return [
              h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'batchLabel/saveOrEdit'
                    }
                  }
                ],
                on: {
                  click: () => {
                    this.$nextTick( ()=> {
                      this.labelFid = params.row.fid;
                      this.addU++;
                    })
                  }
                },
                style: {
                  marginRight: '10px',
                  display:params.row['labelIsValid']===0?'none':''
                }
              }, '编辑'),
              h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'batchLabel/stopOrStartLabel'
                    }
                  }
                ],
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '停用标签',
                      content: '<p>确认停用本条标签？</p>',
                      onOk: () => {
                        const params2 = {
													labelFid:params.row['fid'],
													isValid:params.row['labelIsValid']===1?0:1
                        }
                        stopOrStartLabel(params2)
                        .then( res => {
                          if(res.code === 0){
                            this.$Message.success('停用成功')
                            this.getSearchData();
                          } else{
                            this.$Message.info( '停用失败')
                          }
                        })
                        .catch( () => {
                          this.$Message.info( '停用失败')
                        })
                        .finally( ()=> {
                          this.isShow = false
                        })
                      }
                    })
                  }
                },
                style: {
                  display:params.row['labelIsValid']===0?'none':''
                }
              }, '停用'),
            ]
          }
        },
        {
          title: ' '
        },
			],
			secondaryType:[],
			secondaryYYType:[],
			houseTypes:[],
      projects:[],
      labelFid:'',
      limit:10,
			applyObject:[
				{
					text:'项目',
					value:1,
				},
				{
					text:'房型',
					value:2
				}
			]
		}
	},
	created(){
    this.search();
		this.getSelectList();
	},
	methods:{
		getSelectList(){
			getConditionList()
			.then(res=>{
				this.secondaryType = res.data.secondaryType;
			})
			.catch(err=>{
				console.log(err)
			})
			projectHoseTypeInfo()
			.then(res=>{
				this.houseTypes = res.data.houseTypes;
				this.projects = res.data.projects;
			})
			.catch(err=>{
				console.log(err)
			})
			getYYConditionList().then(res=>{
				if(!res.data){
					return
				}
				this.secondaryYYType=res.data.secondaryYYType


			}).catch((err)=>{
        console.log(err)
      })
		},
		search(data){
      this.page=1
      this.current=1
      this.searchParams = data;
      this.getSearchData();
    },
    getSearchData(){
      const searchParams = {
        labelType:5,
				page:this.page,
        limit:this.limit,
        ...this.searchParams
      }
      getList(searchParams)
      .then( res=> {
        this.data = res.data.rows;
        this.total = res.data.total
        this.data.forEach(ele=>{
          ele.projectOrHouseTypeNames = ele.projectOrHouseTypeNames.join(',')
        })
      })
      .catch(err=>{
        console.log(err)
      })
    },
		changePage(n){
      this.current = n;
      this.page = n;
      this.getSearchData()
    },
	}
}
</script>
